export const DATASETS_MODULES = Object.freeze({
  TRAJECTORY: 'Trajectory',
  ANTI_COLLISION: 'Anti Collision',
  SECTION_DETAILS: 'Section Details',
  LOAD_CASES: 'Load Cases',
  THERMAL_SIMULATIONS: 'Thermal Simulations',
  AFE_APB: 'AFE/APB',
  BLOWOUT_SIMULATIONS: 'Blowout Simulations',
  KILL_SIMULATIONS: 'Kill Simulations'
});

export const LICENSE_ALLOWED_ASSIGNEE = Object.freeze({
  USER: 'user',
  API_KEY: 'api_key',
});

export const ExternalUsersRequestStatusTypes = {
  approved: 'approved',
  pending: 'pending',
  declined: 'declined',
};

export const ExternalUserRequestActionTypes = {
  approve: 'approve',
  reject: 'reject',
};

export const AuditLogTypes = {
  Roles: 'roles',
  Customer: 'customer',
};

export const RestrictedFeatureTypes = {
  ai: 'ai',
  bggm: 'bggm',
};

export const UNAUTHORIZED_STATUS = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const SERVER_ERROR = 500;
export const BAD_REQUEST = 400;
export const CONFLICT = 409;
export const GONE = 410;

export const OLIASOFT_ONLY_LICENSE = 'Oliasoft Internal Team';
export const OLIASOFT_USER_EMAIL_TYPES = /@(oliasoft|avenga|perfectial).com$/;

export const WELLDESIGN = 'welldesign';
export const CUSTOMER_ADMIN_CLIENT_ID = 'customer-admin';
export const CRON_EMAIL = 'cron@oliasoft.com';
